/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Recipe_Meal_Prep_DaysInputs */

const en_recipe_meal_prep_days = /** @type {(inputs: Recipe_Meal_Prep_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meal prep · ${i?.days} days`)
};

const de_recipe_meal_prep_days = /** @type {(inputs: Recipe_Meal_Prep_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meal-Prep · ${i?.days} Tage`)
};

/**
* | output |
* | --- |
* | "Meal prep · {days} days" |
*
* @param {Recipe_Meal_Prep_DaysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_meal_prep_days = /** @type {((inputs: Recipe_Meal_Prep_DaysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Meal_Prep_DaysInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_meal_prep_days(inputs)
	return en_recipe_meal_prep_days(inputs)
});